module.exports = __webpack_public_path__ + "img/parraplax.14d48cda.jpg";